module.exports = __webpack_public_path__ + "img/AEDC-LOGO.e04f53e2.svg";